export default __webpack_public_path__ + "media/images/btn-import_v2-90aaf42b2b09e3a74983645f71cf74f7.png";